import useSidebarPermissions, {
  ROUTE_PERMISSION_MAP,
} from "@/hooks/general/useSidebarPermissions";
import { Navigate, Outlet } from "react-router-dom";

interface RequirePermissionProps {
  menuId?: string;
  routePrefix?: string;
}

/**
 * Route-level permission guard.
 *
 * Usage (pick one):
 *   <RequirePermission menuId="billing" />      — check by menu id directly
 *   <RequirePermission routePrefix="/billing" /> — resolve menu id from ROUTE_PERMISSION_MAP
 *
 * Renders <Outlet /> when allowed, otherwise redirects to the first accessible page.
 */
const RequirePermission = ({ menuId, routePrefix }: RequirePermissionProps) => {
  const { isItemAccessible, firstAccessiblePath } = useSidebarPermissions();

  const resolvedId =
    menuId ?? (routePrefix ? ROUTE_PERMISSION_MAP[routePrefix] : undefined);

  if (!resolvedId || isItemAccessible(resolvedId)) {
    return <Outlet />;
  }

  return <Navigate to={firstAccessiblePath} replace />;
};

export default RequirePermission;
